/**
 * Replace icons to the default one if the image file is not found.
 */
export const ReplaceIcon = function() {
	const typeImages = document.querySelectorAll(".type_icon");
	// console.log(typeImages);

	if (typeImages.length > 0) {
		typeImages.forEach( (iconImg) => {
			iconImg.addEventListener("error", function(event) {
				// console.log(event);
				const img = event.target;
				const isSports = img.classList.contains("sports");
				let type = "arts";
				if (isSports) {
					type = "sports";
				}
				const newFileName = `icon_common-${type}.svg`;
				const currentSrc = img.getAttribute('src');
				const lastSlashIndex = currentSrc.lastIndexOf('/');
				const newSrc = currentSrc.substring(0, lastSlashIndex + 1) + newFileName;
				img.setAttribute('src', newSrc);
			});
		});
	}
}
